const createWidgetTemplateFactory = require('components-framework/widget/create_widget_template_factory');

module.exports = createWidgetTemplateFactory({
    viewClass: require('./view'),
    templates: {
        main: require('components/flights/stop_details/templates/mobile/main.html'),
    },
    stopDetailsItemFactory: require('components/flights/stop_details_item/js/main.mobile'),
});
